import { render } from "./PharmacyList.vue?vue&type=template&id=61f07e52&scoped=true"
import script from "./PharmacyList.vue?vue&type=script&lang=js"
export * from "./PharmacyList.vue?vue&type=script&lang=js"

import "./PharmacyList.vue?vue&type=style&index=0&id=61f07e52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f07e52"]])

export default __exports__